var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"18px","font-weight":"700","padding":"20px 240px 0 20px","text-align":"right"}},[_vm._v("Time remaining："+_vm._s(_vm.hour)+":"+_vm._s(_vm.minute)+":"+_vm._s(_vm.second))])}
var staticRenderFns = []

export { render, staticRenderFns }